import axios from "axios";
import { APIGATEWAY } from '../main_config';

const getDiagnosticos = ({ headers, ...options }) => {

    return axios({
        method: 'GET',
        baseURL: APIGATEWAY.URL,
        url: '/api-smg/v1/gpc/ausentismo/diagnosticos-cedi',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            ...headers
        },
        ...options,
    });

};

export const requestGetDiagnosticosApiManager = async (token, configRequest) => {

    return getDiagnosticos({
        ...configRequest,
        headers: {
            ...configRequest.headers,
            Authorization: `Bearer ${token}`
        }
    });
};